export default "__VITE_ASSET__Dp3wriey__"